import { removeValue } from './removeValue.ts';

/**
 * Returns a new array with the first value that causes test to return true removed.
 */
export function removeValueMatching<T>(arr: readonly T[], test: (value: T, index: number, arr: readonly T[]) => boolean): T[] {
  const value = arr.find(test);

  return removeValue(arr, value);
}